import React, { useState } from "react";
import { TextField, Button, Fade, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { PaymentLinkCopyIcon } from "../../../../../assets/icons/MUI/PaymentIcons";

const CopyableTextField = ({ link }: { link: string }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };

  const buttonText = copied
    ? t("pages.payment.createPaymentLink.copiedLink")
    : t("pages.payment.createPaymentLink.copyLink");

  return (
    <Box
      sx={{
        display: "flex",
        borderRadius: "8px",
        border: "1px solid var(--Gray-300, #D0D5DD)",
      }}
    >
      <TextField
        fullWidth
        value={link}
        sx={{
          "& .MuiInputBase-root.MuiOutlinedInput-root, & .MuiOutlinedInput-notchedOutline": {
            border: "none !important",
          },
        }}
      />
      <Button
        onClick={handleCopy}
        startIcon={<PaymentLinkCopyIcon />}
        sx={{
          color: "var(--Green---100, #106048)",
          fontFamily: "Montserrat",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "24px",
          borderRadius: "unset !important",
          textWrap: "nowrap",
          padding: "10px 18px",
          borderLeft: "1px solid #D0D5DD",
          position: "relative",
          overflow: "hidden",
          minWidth: "120px",
        }}
      >
        <Box sx={{ position: "relative" }}>
          <Fade in={true} key={buttonText} timeout={500}>
            <Box component="span">{buttonText}</Box>
          </Fade>
        </Box>
      </Button>
    </Box>
  );
};

export default CopyableTextField;
